/**
 * 设置 / 公司信息(只读 + 退出)。
 *
 * MVP:展示公司名 / 手机号 / 注册时间。修改密码 / 改公司名 留待后续。
 */

import { useAuth } from '../lib/AuthContext';

export default function AdminAccount() {
  const { tenant, logout } = useAuth();

  if (!tenant) return null;

  return (
    <div className="container narrow">
      <div className="page-header">
        <div>
          <h1 className="title">公司信息</h1>
          <div className="subtitle">设置 · 公司基础信息</div>
        </div>
      </div>

      <div className="card">
        <div className="row" style={{
          padding: 20,
          background: 'var(--bg-elev)',
          borderRadius: 10,
          marginBottom: 24,
          gap: 16,
        }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%',
            background: 'var(--accent)',
            color: 'white',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 26, fontWeight: 600,
          }}>
            {tenant.company_name[0]}
          </div>
          <div>
            <div style={{ fontSize: 20, fontWeight: 600 }}>{tenant.company_name}</div>
            <div className="muted" style={{ fontSize: 14, marginTop: 4 }}>{tenant.phone}</div>
          </div>
        </div>

        <div className="col" style={{ gap: 16 }}>
          <Field label="公司名称" value={tenant.company_name} />
          <Field label="登录手机号" value={tenant.phone} />
          <Field label="注册时间" value={new Date(tenant.created_at).toLocaleString('zh-CN')} />
          <Field label="账号类型" value="公司管理员(单账号)" />
        </div>
      </div>

      <div className="card">
        <h2 style={{ marginBottom: 8 }}>账号操作</h2>
        <div className="hint" style={{ marginBottom: 16 }}>
          后续可加修改密码 / 邀请成员 / 退订等
        </div>
        <button className="ghost" onClick={logout} style={{ color: 'var(--danger)' }}>
          退出登录
        </button>
      </div>
    </div>
  );
}

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="hint" style={{ fontSize: 12, marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 15 }}>{value}</div>
    </div>
  );
}
